// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade, Autoplay } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/swiper-bundle.css';

// init Swiper:
// const swiper = new Swiper('.swiper-container', {
//   // configure Swiper to use modules
//   modules: [Navigation, Pagination],
//     direction: 'horizontal',
//     loop: true,

//     // If we need pagination
//     pagination: {
//         el: '.swiper-pagination',
//         clickable: true
//     },

//     // Navigation arrows
//     navigation: {
//         nextEl: '.swiper--next',
//         prevEl: '.swiper--prev',
//     },

//     // And if we need scrollbar
//     scrollbar: {
//         el: '.swiper-scrollbar',
//     }
// });


/**
 * Swiper neu messen — nach Bild-/responsive Reflow (picture, srcset, Fonts).
 * Ein einzelnes rAF reicht oft nicht, wenn Layout in derselben Frame-Kette noch ändert.
 */
const recalcSwiper = (swiper) => {
    if (!swiper || typeof swiper.update !== 'function') {
        return;
    }
    swiper.update();
    requestAnimationFrame(() => {
        if (!swiper || typeof swiper.update !== 'function') {
            return;
        }
        swiper.update();
    });
};

const attachSwiperLayoutObservers = (sliderEl, swiper) => {
    let roFrame = null;
    const schedule = () => {
        if (roFrame) {
            return;
        }
        roFrame = requestAnimationFrame(() => {
            roFrame = null;
            recalcSwiper(swiper);
        });
    };

    if (typeof ResizeObserver !== 'undefined') {
        const ro = new ResizeObserver(schedule);
        ro.observe(sliderEl);
        const wrapper = sliderEl.querySelector('.swiper-wrapper');
        if (wrapper) {
            ro.observe(wrapper);
        }
    }

    sliderEl.querySelectorAll('img').forEach((img) => {
        img.addEventListener('load', schedule);
        if (img.decode && typeof img.decode === 'function') {
            img.decode().then(schedule).catch(() => {});
        }
        if (img.complete) {
            schedule();
        }
    });
};

// Get CSS variable value for spaceBetween
const getSpace12Value = () => {
    // Create a temporary element to get the computed value
    const tempEl = document.createElement('div');
    tempEl.style.width = 'var(--space-12)';
    tempEl.style.position = 'absolute';
    tempEl.style.visibility = 'hidden';
    document.body.appendChild(tempEl);
    
    const computedValue = getComputedStyle(tempEl).width;
    document.body.removeChild(tempEl);
    
    // Parse the pixel value
    return parseFloat(computedValue) || 20;
};

// Initialize center align sliders
const swiperCenters = [];
const centerSliders = document.querySelectorAll('.center--align--slider');
if (centerSliders.length) {
    centerSliders.forEach((sliderEl) => {
        const nextEl = sliderEl.querySelector('.swiper--next');
        const prevEl = sliderEl.querySelector('.swiper--prev');

        const swiperCenter = new Swiper(sliderEl, {
            modules: [Navigation],
            direction: 'horizontal',
            loop: false,
            slidesPerView: 1.1,
            spaceBetween: getSpace12Value(),
            slideToClickedSlide: true,
            breakpoints: {
              768: {
                slidesPerView: 1.3,
                centeredSlides: false,
              }
            },
            navigation: {
                nextEl,
                prevEl,
            },
            observer: true,
            observeParents: true,
            watchSlidesProgress: true,
            on: {
                init(s) {
                    recalcSwiper(s);
                    attachSwiperLayoutObservers(sliderEl, s);
                },
            },
        });

        // Falls Bilder schon gecacht: nach vollem Page-Load nochmal messen.
        window.addEventListener('load', () => recalcSwiper(swiperCenter), { once: true });

        swiperCenters.push(swiperCenter);
    });
}

// Initialize news slider only if element exists
let swiperNews = null;
const newsSlider = document.querySelector('.news--slider');
if (newsSlider) {
    swiperNews = new Swiper('.news--slider', {
        modules: [Navigation],
        direction: 'horizontal',
        loop: false,
        slidesPerView: 1.2,
        spaceBetween: getSpace12Value(),
        watchSlidesProgress: true,
        breakpoints: {
            768: {
                slidesPerView: 2.2,
            },
            1024: {
                slidesPerView: 3,
            }
        },
        navigation: {
            nextEl: '.swiper--next',
            prevEl: '.swiper--prev',
        },
    });
}

// Testimonial slider with thumbnail pagination
const initTestimonialSlider = () => {
    const testimonialSlider = document.querySelector('.testimonial--slider');
    if (!testimonialSlider) return;

    // Collect thumbnail images from data attributes
    const slides = testimonialSlider.querySelectorAll('.swiper-slide');
    const thumbnails = [];
    
    slides.forEach((slide) => {
        const thumbnailUrl = slide.getAttribute('data-thumbnail') || '';
        thumbnails.push(thumbnailUrl);
    });

    const paginationEl = testimonialSlider.querySelector('.testimonial--pagination');
    
    const swiperTestimonial = new Swiper('.testimonial--slider', {
        modules: [Pagination, EffectFade, Autoplay],
        direction: 'horizontal',
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        pagination: {
            el: paginationEl,
            clickable: true,
            renderBullet: function (index, className) {
                const thumbnail = thumbnails[index] || '';
                if (thumbnail) {
                    return '<span class="' + className + ' testimonial--pagination--bullet"><img src="' + thumbnail + '" alt="" /></span>';
                }
                return '<span class="' + className + '"></span>';
            },
        },
        on: {
            init: function() {
                // Verschiebe Pagination in das .left div des aktiven Slides
                const activeSlide = this.slides[this.activeIndex];
                const leftDiv = activeSlide?.querySelector('.left');
                if (leftDiv && paginationEl) {
                    leftDiv.appendChild(paginationEl);
                }
            },
            slideChange: function() {
                // Verschiebe Pagination in das .left div des neuen aktiven Slides
                const activeSlide = this.slides[this.activeIndex];
                const leftDiv = activeSlide?.querySelector('.left');
                if (leftDiv && paginationEl && paginationEl.parentNode !== leftDiv) {
                    leftDiv.appendChild(paginationEl);
                }
            },
        },
    });
};

// Initialize testimonial slider when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTestimonialSlider);
} else {
    initTestimonialSlider();
}

// Update spaceBetween on window resize
let resizeTimeout;
window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
        const newSpaceValue = getSpace12Value();
        
        swiperCenters.forEach((swiperCenter) => {
            swiperCenter.params.spaceBetween = newSpaceValue;
            swiperCenter.update();
        });
        
        if (swiperNews) {
            swiperNews.params.spaceBetween = newSpaceValue;
            swiperNews.update();
        }
    }, 150); // Debounce resize events
});